<template>
  <div class="bar-chart-fixed">
    <div class="chart-container">
      <div v-if="bars && bars.length > 0" class="bars">
        <div 
          v-for="(bar, index) in bars" 
          :key="`bar-${index}`"
          class="bar-column">
          <ChartTooltip 
            :tooltip-style="tooltipStyle"
            :offset-x="10"
            :offset-y="40"
            style="width: 100%; height: 100%; display: flex; align-items: flex-end;">
            <div 
              :class="['bar', { 'blinking': bar.blinking }]" 
              :style="{
                height: `${bar.height}%`,
                backgroundColor: bar.color || '#56ca00'
              }">
            </div>
            <template v-slot:tooltip>
              {{ bar.tooltip || `Bar ${index + 1}` }}
            </template>
          </ChartTooltip>
        </div>
      </div>
      <div v-else class="no-data">
        No data available
      </div>
    </div>
  </div>
</template>

<script>
import ChartTooltip from './ChartTooltip.vue';

export default {
  name: 'BarChartFixed',
  components: {
    ChartTooltip
  },
  props: {
    bars: {
      type: Array,
      required: true
    },
    tooltipStyle: {
      type: Object,
      default: () => ({
        backgroundColor: '#fff',
        borderRadius: '8px',
        boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
        padding: '8px 12px',
        fontSize: '14px',
        color: '#333',
        whiteSpace: 'nowrap'
      })
    }
  },
};
</script>

<style scoped>
.bar-chart-fixed {
  width: 100%;
}

.chart-container {
  width: 100%;
  height: 80px;
  background-color: #f9f9f9;
  border-radius: 6px;
  padding: 6px;
  border: 1px solid #f0f0f0;
}

.bars {
  display: flex;
  align-items: flex-end;
  height: 100%;
  gap: 2px;
}

.bar-column {
  flex: 1;
  height: 100%;
  display: flex;
  align-items: flex-end;
}

.bar {
  width: 100%;
  min-height: 2px;
  background-color: #56ca00;
  transition: all 0.3s ease;
  border-radius: 2px 2px 0 0;
}

.bar.blinking {
  animation: blink 1s infinite;
}

@keyframes blink {
  0%, 100% {
    background-color: #b21b05;
  }
  50% {
    background-color: #ff2000;
  }
}

.bar:hover {
  opacity: 0.8;
}

.no-data {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #999;
  font-size: 14px;
}
</style>